var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { style: _vm.lines.Style.getStyle() }, [
    _vm._v(" " + _vm._s(_vm.lines.Value.getTranslation(_vm.lang)) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }